import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('hi'); // 'hi' = Hindi, 'en' = English

  const toggle = () => setLang(prev => prev === 'hi' ? 'en' : 'hi');

  return (
    <LanguageContext.Provider value={{ lang, toggle, isHindi: lang === 'hi' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
